// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"94":"9cfef8ce7a207071b202","236":"2ad19236bba8c75251fc","632":"bf1b11ec30f53f3e8743"}[chunkId] + ".js";
};